import type {ReactElement} from 'react';
import React from 'react';
import {ContextualMenuInputsOption} from '@Components/contextual-menu/components/contextual-menu-inputs-option';
import {MAX_POSTER_NAME_LENGTH} from '@PosterWhiteboard/poster/poster.types';
import {useAppSelector} from '@/hooks';

export function DesignNameOption(): ReactElement<any> | null {
  const currentDesignName = useAppSelector((state) => {
    return state.posterEditor.posterObject?.name;
  });

  const updateName = (value: string, undoable = true): void => {
    void window.posterEditor?.whiteboard?.updateFromObject(
      {
        name: value,
      },
      {
        undoable,
      }
    );
  };

  const onChange = (value: string): void => {
    updateName(value, false);
  };

  const onChangeEnded = (value: string): void => {
    updateName(value);
  };

  return (
    <ContextualMenuInputsOption
      id="design-name-edit-option"
      value={currentDesignName}
      onInputChange={onChange}
      onInputChangeEnded={onChangeEnded}
      elementTitle={window.i18next.t('pmwjs_title')}
      maxLength={MAX_POSTER_NAME_LENGTH}
    />
  );
}
